import { Store } from "pullstate"

export const Pullstate = new Store({
   isChapterNavInView: false,
   isCoverLoaded: false,
   globalBreakpoint: '',
   isEdgeHTML: false,
})
